// Global Instructions Rule Applied!
//
// Email Settings — minimal Phase 2 surface (per the plan):
//   * My signature (Jodit editor + live preview, PATCH /email/me/signature)
//   * Manage delegations (granted-to-me + granted-by-me lists; grant + revoke)
//
// Two AntD tabs. Both panels are self-contained: their own loading state,
// their own fetch + save calls. No Redux slice — these are session-scoped
// settings, not list-shaped data.

import React, { useState } from 'react'
import { Tabs, Typography } from 'antd'
import { MySignatureTab } from './components/MySignatureTab.tsx'
import { DelegationsTab } from './components/DelegationsTab.tsx'

const { Title } = Typography

export default function EmailSettingsPage() {
  const [activeKey, setActiveKey] = useState<string>('signature')

  return (
    <div className='h-full overflow-hidden'>
      <div className='w-full h-full flex flex-col bg-white px-4 py-3 overflow-hidden'>
        <Title level={4} style={{ margin: '0 0 8px 0' }}>
          Email Settings
        </Title>
        <Tabs
          activeKey={activeKey}
          onChange={setActiveKey}
          destroyInactiveTabPane={false}
          items={[
            { key: 'signature',   label: 'My signature',     children: <MySignatureTab /> },
            { key: 'delegations', label: 'Manage delegations', children: <DelegationsTab /> }
          ]}
          className='flex-1 min-h-0'
        />
      </div>
    </div>
  )
}
